export default {"src":"/_next/static/media/bloomberg.9282b4fd.svg","height":35,"width":171,"blurWidth":0,"blurHeight":0};